function submitAddToCartForm(form, btn) {
  btn.classList.add("loading");
  btn.disabled = true;

  const iconSrc = btn.dataset.iconSrc || "/assets/bag-icon.svg";
  const textEl = btn.querySelector(".btn-text");
  const formData = new FormData(form);

  fetch("/cart/add.js", { method: "POST", body: formData })
    .then((r) => {
      if (!r.ok) throw new Error("Cart add failed");
      return r.json();
    })
    .then(() => {
      return Promise.all([
        fetch("/?sections=mini-cart").then((r) => r.json()),
        fetch("/cart.js").then((r) => r.json()),
      ]);
    })
    .then(([sectionData, cartData]) => {
      // Button restore
      btn.disabled = false;
      btn.classList.remove("loading");
      if (textEl) {
        textEl.innerHTML = `✔ Added`;
        setTimeout(() => {
          textEl.innerHTML = `<img src="${iconSrc}" alt=""> Add to bag`;
        }, 2000);
      }

      // Mini-cart update
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionData["mini-cart"], "text/html");
      const newContent = doc.querySelector("#shopify-section-mini-cart");
      const currentContent = document.querySelector(
        "#shopify-section-mini-cart",
      );
      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      }

      // Cart count badge
      const el = document.querySelector("[data-cart-count]");
      if (el && cartData.item_count > 0) {
        el.textContent = cartData.item_count;
        el.removeAttribute("hidden");
        el.classList.remove("bump");
        void el.offsetWidth;
        el.classList.add("bump");
      }

      // Cart drawer open (only if custom drawer exists in DOM)
      const customDrawer = document.querySelector(".custom-cart-drawer");
      if (customDrawer) {
        customDrawer.classList.add("is-open");
        document
          .querySelector(".cart-drawer-overlay")
          ?.classList.add("is-open");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.body.classList.add("cart-open");
      }

      document.dispatchEvent(new CustomEvent("cart:added"));
    })
    .catch((err) => {
      console.error("Cart error:", err);
      btn.disabled = false;
      btn.classList.remove("loading");
      if (textEl) {
        textEl.innerHTML = `<img src="${iconSrc}" alt=""> Add to bag`;
      }
      // Error par bhi sticky restore karo
      document.dispatchEvent(new CustomEvent("cart:added"));
    });
}

function submitBuyNowForm(form, btn) {
  const formData = new FormData(form);
  const variantId =
    formData.get("id") || form.querySelector('[name="id"]')?.value;
  const quantity =
    formData.get("quantity") ||
    form.querySelector('[name="quantity"]')?.value ||
    "1";

  if (!variantId) {
    alert("Please select a product variant first.");
    return;
  }

  // Extract properties
  const properties = {};
  for (const [key, value] of formData.entries()) {
    if (key.startsWith("properties[") && value) {
      const propKey = key.replace(/^properties\[|\]$/g, "");
      properties[propKey] = value;
    }
  }

  const buyNowItem = {
    variant_id: Number(variantId),
    quantity: Number(quantity) || 1,
    ...(Object.keys(properties).length > 0 ? { properties } : {}),
  };

  btn.classList.add("loading");
  btn.disabled = true;

  // Launch FlexyPe with ONLY this single item in its payload
  if (typeof window.openFlexyCheckout === "function") {
    try {
      window.openFlexyCheckout("buy-now", undefined, [buyNowItem]);
      setTimeout(() => {
        btn.classList.remove("loading");
        btn.disabled = false;
      }, 1000);
      return;
    } catch (e) {
      console.warn("FlexyPe buy-now error:", e);
    }
  }

  // Fallback to Shopify single-item permalink
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(properties)) {
    params.append(`properties[${k}]`, v);
  }
  const queryString = params.toString();
  window.location.href = `/cart/${variantId}:${quantity}${queryString ? "?" + queryString : ""}`;
}

function isPersonalizedForm(form) {
  if (form.dataset.personalized === "true") return true;

  const card =
    form.closest(".product-card") ||
    form.closest(".product-card-item") ||
    form.closest(".custom-tabbed-products-card") ||
    form.closest(".product-slider-card") ||
    form.closest("[data-product-card]") ||
    form.parentElement;

  const titleText = (
    card?.querySelector(
      ".product-title, h1, h2, h3, h4, .prod-title, .title-text",
    )?.textContent || ""
  ).toLowerCase();

  if (
    titleText.includes("personalized") ||
    titleText.includes("personalised") ||
    titleText.includes("pouch")
  ) {
    return true;
  }

  return false;
}

// Click par Add To Bag handler
document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".btn-add-to-bag");
    if (!btn) return;

    // Modal ke andar confirm button ko skip karo
    if (btn.closest("#personalization-modal-overlay")) return;

    // Sticky button skip karo — uska apna listener hai
    if (btn.classList.contains("sticky-add-to-cart")) return;

    const form = btn.closest("form");
    if (!form) return;

    // ✅ 1. Check for inline personalization input (e.g. on product page)
    const personInput = form.querySelector(".personalization-input");
    if (personInput) {
      if (personInput.value.trim() === "") {
        personInput.focus();
        personInput.style.border = "2px solid red";
        personInput.placeholder = "Please enter name first!";
        return;
      }
    } else if (isPersonalizedForm(form)) {
      // ✅ 2. Product is personalized but has no inline input (e.g. collection / listing page)
      // Always open modal so each item added gets its own personalization name
      e.preventDefault();
      e.stopPropagation();
      openPersonalizationModal(form, btn, false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    submitAddToCartForm(form, btn);
  },
  true,
);

// Click par Buy Now handler
document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".btn-buy-now");
    if (!btn) return;

    // Modal ke andar confirm button ko skip karo
    if (btn.closest("#personalization-modal-overlay")) return;

    // Sticky button skip karo — uska apna listener hai
    if (btn.classList.contains("sticky-buy-now")) return;

    const form =
      btn.closest("form") ||
      document.querySelector("#product-form") ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // ✅ 1. Check for inline personalization input
    const personInput = form.querySelector(".personalization-input");
    if (personInput) {
      if (personInput.value.trim() === "") {
        personInput.focus();
        personInput.style.border = "2px solid red";
        personInput.placeholder = "Please enter name first!";
        return;
      }
    } else if (isPersonalizedForm(form)) {
      e.preventDefault();
      e.stopPropagation();
      openPersonalizationModal(form, btn, true);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    submitBuyNowForm(form, btn);
  },
  true,
);

// Modal Logic
function openPersonalizationModal(form, btn, isBuyNow = false) {
  const modal = document.getElementById("personalization-modal-overlay");
  if (!modal) return;

  const input = document.getElementById("personalization-modal-input");
  const atcBtn = document.getElementById("personalization-modal-confirm");
  const buyNowBtn = document.getElementById(
    "personalization-modal-confirm-buynow",
  );
  const closeBtn = modal.querySelector(".personalization-modal-close");
  const errorMsg = modal.querySelector(".personalization-modal-error");

  // Reset modal state
  input.value = "";
  input.style.border = "";
  if (errorMsg) errorMsg.style.display = "none";

  modal.classList.add("is-active");
  setTimeout(() => input.focus(), 100);

  const closeModal = () => {
    modal.classList.remove("is-active");
  };

  closeBtn.onclick = closeModal;
  modal.onclick = (e) => {
    if (e.target === modal) closeModal();
  };

  input.oninput = () => {
    input.style.border = "";
    if (errorMsg) errorMsg.style.display = "none";
  };

  const handleAction = (forBuyNow) => {
    const name = input.value.trim();
    if (!name) {
      input.style.border = "2px solid red";
      if (errorMsg) errorMsg.style.display = "block";
      input.focus();
      return;
    }

    // Remove any previously added hidden personalization properties from this form
    form
      .querySelectorAll('input[name="properties[Personalisation Name]"]')
      .forEach((el) => el.remove());

    // Add hidden input to form
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "properties[Personalisation Name]";
    hiddenInput.value = name;
    form.appendChild(hiddenInput);

    closeModal();
    if (forBuyNow) {
      submitBuyNowForm(form, btn);
    } else {
      submitAddToCartForm(form, btn);
    }
  };

  if (atcBtn) atcBtn.onclick = () => handleAction(false);
  if (buyNowBtn) buyNowBtn.onclick = () => handleAction(true);

  input.onkeydown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAction(isBuyNow);
    }
  };
}
